module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10217.024fad2a.jpg";